function base64UrlDecode(str) {
  const s = str.replace(/-/g, '+').replace(/_/g, '/')
  const padded = s + '==='.slice((s.length + 3) % 4)
  return atob(padded)
}

function getKlaviyoCookie(name) {
  return document.cookie
    .split('; ')
    .find(c => c.startsWith(name + '='))
    ?.split('=')
    .slice(1)
    .join('=') || ''
}

function logKlaviyoEmailFromCookie() {
  const raw = decodeURIComponent(getKlaviyoCookie('__kla_id'))
  if (!raw) {
    console.log('No __kla_id cookie found')
    return
  }

  try {
    const json = base64UrlDecode(raw)
    const payload = JSON.parse(json)

    console.log('__kla_id payload:', payload)
    console.log('Email:', payload.$email || payload.email || payload?.customer_properties?.$email)
  } catch (e) {
    console.log('Could not decode __kla_id as JSON. Raw value:', raw)
    console.log('Decode error:', e)
  }
}

logKlaviyoEmailFromCookie()